import { useMediaQuery } from 'react-responsive'

// TODO: get this from theme
const LG = 1280
const SM = 767

export const useIsDesktop = () => {
  return useMediaQuery({ query: `(min-width: ${LG + 1}px)` })
}

export const useIsTabletOrMobile = () => {
  return useMediaQuery({ query: `(max-width: ${LG}px)` })
}

export const useIsTablet = () => {
  return useMediaQuery({ query: `(min-width: ${SM + 1}px) and (max-width: ${LG}px)` })
}

export const useIsMobile = () => {
  return useMediaQuery({ query: `(max-width: ${SM}px)` })
}
